import React from 'react'
import { NextPage } from 'next'
import {
  StorefrontEventWithProducts,
  getEvent
} from '@/modules/event/getEvent'
import StorePage from '@/modules/shared/components/StorePage'

type EventPageProps = {
  event: StorefrontEventWithProducts
}

const EventPage: NextPage<EventPageProps> = (props: EventPageProps) => {

  const { event } = props

  return (
    <StorePage
      event={event}
      prefix={'EventPage'}
    />
  )
}

export default EventPage

export async function getServerSideProps(context): Promise<any> {
  const { eventId } = context.params
  const eventData = await getEvent(eventId)

  if (!eventData) {
    return {
      notFound: true
    }
  }

  const eventMicrosite = `${process.env.CTLIVE_MICROSITE_URL}/event/${eventId}`

  if (eventData.isRegistrationDisabled) {
    return {
      redirect: {
        destination: eventMicrosite,
        permanent: false,
      }
    }
  }

  const products = eventData.products
          .filter(product => product.availableInStorefront)

  const event = {
    ...eventData,
    products: products
  }

  return {
    props: {
      event
    },
  }
}
